export enum RunRoleEnum {
  Owner = 1,
  Member = 2,
  AdditionalParticipant = 3,
}
